import React, { useState } from 'react'
import { Navigate } from 'react-router-dom'
import { FormRender } from 'choice-forms'
import { post } from '../utils/apiClient'
import { useAccount } from '../entities'
import { Link } from 'react-router-dom'
import { Grid, Header, Segment } from 'semantic-ui-react'
import ConfirmUser from '../components/Account/ConfirmUser'
import LogoName from '../components/Layout/LogoName'
// import { FormMessage } from 'choice-forms'

export default function Register() {
  const [accountData] = useAccount()
  // const [, { updateUser }] = useUser()
  const [state, setState] = useState({
    userToConfirm: null,
    form_message: '',
    is_loading: false,
    is_logo: true,
    account_message: '',
    account_form: {
      key: 'account_form',
      name: 'Account',
      components: [
        {
          key: 'first_name',
          type: 'textfield',
          label: 'First name',
          validate: { required: true }
        },
        {
          key: 'last_name',
          type: 'textfield',
          label: 'Last name',
          validate: { required: true }
        },
        {
          key: 'email',
          type: 'textfield',
          label: 'Email',
          validate: { required: true }
        },
        {
          key: 'phone',
          type: 'textfield',
          label: 'Phone',
          mask: '999-999-9999',
          validate: { required: true }
        },
        {
          key: 'password',
          type: 'password',
          label: 'Password',
          validate: { required: true }
        }
      ]
    }
  })

  const onSubmitForm = async ({ submission }) => {
    if (state.is_loading) {
      return false
    }
    setState({ ...state, is_loading: true })
    let res = await post('/api/register-user', {
      data: submission,
      show_msg: false
    })
    if (res.ok) {
      setState({
        ...state,
        is_loading: false,
        userToConfirm: { ...submission }
      })
      return res
    } else {
      // error
      setState({
        ...state,
        is_loading: false
      })
      return res
    }
  }

  const { accountSettings } = accountData

  if (!accountSettings.isAllowRegister) {
    return <Navigate to="/signin" replace />
  }

  return (
    <div className="signin-form" style={{ background: '#fff' }}>
      <Grid textAlign="center" style={{ height: '100vh' }}>
        <Grid.Column
          style={{ maxWidth: 450, marginTop: '3rem' }}
          className="mr-4 ml-4">
          <LogoName />

          {state.userToConfirm ? (
            <>
              <Header as="h2" textAlign="center" style={{ color: '#1472A4' }}>
                {' '}
                Confirm User Account
              </Header>
              <ConfirmUser userToConfirm={state.userToConfirm} />
            </>
          ) : (
            <>
              <Header as="h2" textAlign="center" style={{ color: '#1472A4' }}>
                {' '}
                Create User Account
              </Header>
              <div style={{ textAlign: 'left' }}>
                <FormRender
                  form={state.account_form}
                  data={{}}
                  form_header="Create Account"
                  hide_delete={true}
                  cancel_btn={false}
                  onSubmitForm={onSubmitForm}
                  clientApi={post}
                />
              </div>
              <Segment
                basic
                textAlign="left"
                size="small"
                className="pt-0 pb-0 pl-0"
                style={{ marginTop: '3rem' }}>
                Already have an account?
                <Link to="/signin" className="ml-2" tabIndex="5">
                  Sign in
                </Link>
              </Segment>
            </>
          )}
        </Grid.Column>
      </Grid>
    </div>
  )
}
